import { render, staticRenderFns } from "./Comparisons.vue?vue&type=template&id=31b41e45&scoped=true&"
import script from "./Comparisons.vue?vue&type=script&lang=js&"
export * from "./Comparisons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b41e45",
  null
  
)

export default component.exports